module.exports = __webpack_public_path__ + "img/recently_launched_large.ff02311e.png";